export default "__VITE_ASSET__lxZeRHIL__"